// Hook odpowiedzialny za dopisanie pozycji wybranego zamowienia do koszyka

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// parametry requestu do api
interface IRequest {
  orderId: number;
}

export interface ICartImportFromOrderSkipped {
  order_position_id: number;
  product_id: number | null;
  reason: string;
}

// typ zwracanych danych
interface IResponse extends ICommandResponseSuccess {
  data: {
    added: number;
    merged: number;
    skipped: ICartImportFromOrderSkipped[];
  };
}

const postCartImportFromOrder = (cartId: number, data: IRequest): Promise<IResponse> =>
  axios.post(`/carts/${cartId}/positions/from-order`, data);

export const usePostCartImportFromOrder = (
  cartId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postCartImportFromOrder(cartId, data), options);
